import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { GridConfig } from '@Mobilesentrix/ms-design-system';
import { CommonService } from './shared/services/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly renderer = inject(Renderer2);
   gridConfig = inject(GridConfig)
   commonService = inject(CommonService);
  constructor() {
    ['dateformat', 'currencySymbol', 'currencyFormat'].forEach((key) => {
      const val = localStorage.getItem(key);
      if (val === null) return;
      try {
        JSON.parse(val);
      } catch {
        localStorage.removeItem(key);
      }
    });
    this.gridConfig.dateFormat = this.commonService.getBusinessPrefs().dateFormat;
    this.gridConfig.currencySymbol = this.commonService.getCurrencySymbol();
    this.gridConfig.timeZone = this.commonService.getBusinessTimeZone();
    this.gridConfig.currencyFormat = this.commonService.getCurrencyFormat()
  }

  ngOnInit(): void {
    this.loadGoogleMaps();
  }

  private loadGoogleMaps(): void {
    if (document.getElementById('google-maps-script')) return;
    const key = environment?.googleMapsApiKey ?? '';
    const script = this.renderer.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async&region=US&language=en`;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.head, script);
  }
}
